export default __webpack_public_path__ + "static/media/7.528c9e5d.jpg";